import { Component , TemplateRef, ViewChild, PLATFORM_ID ,Inject, OnInit} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule,MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

import { HttpClient, HttpClientModule } from '@angular/common/http';

@Component({
  selector: 'app-edit-subs-admin',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule,
    HttpClientModule],
  templateUrl: './edit-subs-admin.component.html',
  styleUrl: './edit-subs-admin.component.css'
})
export class EditSubsAdminComponent implements OnInit {
  selectedPlan = '';
  apiAccess = false;
  cambridgeAccess = false;
  isSaving = false;
  organization_size = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditSubsAdminComponent>,
    public fachada: FacadeService,
     private http: HttpClient,
  ) {
    
  }

ngOnInit() {
  // Asignar plan
  this.selectedPlan = this.data.plan?.toString() ?? '';
  this.organization_size = parseInt(this.data.max_users ?? null);

  // Extra permissions vienen como array ['api_access', 'yle_access']
  const perms: string[] = this.data.extraPermissions ?? [];

  this.apiAccess = perms.includes('api_access');
  this.cambridgeAccess = perms.includes('yle_access');

  // if (perms.includes()){

  // }
}





saveChanges() {

  if (this.isSaving) return;

  this.isSaving = true;

  const id_sub = this.data.id;
  const plan = this.selectedPlan;
  let samesize;
  let size = null;
  if (plan == "4" || plan == "5"  || plan == "18"){
    size = this.organization_size
  }
  const extra = [];
  if (this.apiAccess) extra.push("api_access");
  if (this.cambridgeAccess) extra.push("yle_access");

  const token = localStorage.getItem("token");

  const originalExtra = this.data.extraPermissions ?? [];

  const samePlan = plan.toString() === this.data.plan?.toString();
  const sameExtra = JSON.stringify(extra.sort()) === JSON.stringify(originalExtra.sort());
  if (size == null){
    samesize = true
  }else{
    samesize= size.toString() === this.data.max_users?.toString();
  }
  

  if (samePlan && sameExtra && samesize) {
    console.log("No hubo cambios, no se envía petición.");
    this.isSaving = false;
    this.dialogRef.close(false);
    return;
    
  }

  this.fachada.editInfoUser(
    this.http,
    id_sub,
    plan,
    extra,
    token,
    size
  ).then(res => {
    console.log("Respuesta del servidor:", res);
    this.dialogRef.close({
        id: id_sub,
        plan: plan,
        extra_permissions: extra
      });
  }).catch(err => {
    console.error("Error guardando cambios:", err);
    this.isSaving = false; 
  });

}



}
